import React from 'react'
import { Link } from 'react-router-dom'
import { money } from '../financial/formatting'
import { count } from '../staff-leads/model'
import { isHighErrorRate, rate } from './model'

// The range's top partners, by revenue. `blocked` counts intake rejections,
// which are not part of `leads`.
export function TopPartnersTable({ rows = [] }) {
  return (
    <TableCard title="Top partners" id="hm-partners-title" link={{ to: '/affiliates', label: 'All partners →' }} empty={rows.length === 0 && 'No partner activity in this range.'}>
      <table className="hm-table">
        <thead>
          <tr>
            <th scope="col">Partner</th>
            <th scope="col" className="hm-num">Leads</th>
            <th scope="col" className="hm-num">Sale rate</th>
            <th scope="col" className="hm-num">Blocked</th>
            <th scope="col" className="hm-num">Revenue</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((p) => (
            <tr key={p.name}>
              <td>{p.name}</td>
              <td className="hm-num">{count(p.leads)}</td>
              <td className="hm-num">{rate(p.sale_rate)}</td>
              <td className="hm-num" style={{ color: p.blocked > 0 ? 'var(--text-secondary)' : 'var(--text-muted)' }}>{count(p.blocked)}</td>
              <td className="hm-num">{money(p.revenue)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </TableCard>
  )
}

// Every buyer contacted in the range. The name is printed exactly as sent:
// hidden buyers arrive already folded into one "Other buyer" row, with no id,
// and no row here links anywhere, so nothing can name or identify one.
// `notice` is the backend's reason for not computing the breakdown (a range
// longer than it covers): shown instead of "no activity", which would be a
// claim about the buyers.
export function BuyersTable({ rows = [], notice = null }) {
  return (
    <TableCard title="Buyers" id="hm-buyers-title" link={{ to: '/buyers', label: 'All buyers →' }} empty={notice || (rows.length === 0 && 'No buyer activity in this range.')}>
      <table className="hm-table">
        <thead>
          <tr>
            <th scope="col">Buyer</th>
            <th scope="col" className="hm-num">Bought</th>
            <th scope="col" className="hm-num">Win rate</th>
            <th scope="col" className="hm-num">Errors</th>
            <th scope="col" className="hm-num">Revenue</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((b) => {
            const high = isHighErrorRate(b.error_rate)
            return (
              <tr key={b.name}>
                <td>{b.name}</td>
                <td className="hm-num">{count(b.bought)}</td>
                <td className="hm-num">{rate(b.win_rate)}</td>
                <td className="hm-num" data-high-error={high || undefined} style={{ color: high ? 'var(--red)' : undefined, fontWeight: high ? 700 : undefined }}>
                  {rate(b.error_rate)}
                </td>
                <td className="hm-num">{money(b.revenue)}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </TableCard>
  )
}

function TableCard({ title, id, link, empty, children }) {
  return (
    <section className="card" aria-labelledby={id} style={{ padding: 18, display: 'flex', flexDirection: 'column', gap: 10, minWidth: 0 }}>
      <div className="hm-card-head">
        <h2 id={id} style={{ margin: 0, fontSize: 15, fontWeight: 700 }}>{title}</h2>
        <Link className="hm-link" to={link.to}>{link.label}</Link>
      </div>
      {empty
        ? <p style={{ margin: 0, fontSize: 13, color: 'var(--text-muted)' }}>{empty}</p>
        : <div className="hm-table-scroll">{children}</div>}
    </section>
  )
}
